import request from "@/request"

/**
 * 文章列表
 * @param PageParams
 */
export function getArticles(PageParams) {
    return request({
        url: "/articles",
        method: 'POST',
        data: PageParams
    })
}

/**
 * 通过文章id获取文章详情
 * @param PageParams
 */
export function getArticleById(id) {
    return request({
        url: `/articles/view/${id}`,
        method: 'POST'
    })
}

/**
 * 通过token和文章参数发布文章
 * @param PageParams
 */
export function publishArticle(article, token) {
    return request({
        headers: {'Authorization': token},
        url: '/articles/publish',
        method: 'post',
        data: article
    })
}

/**
 * 获取最热文章列表
 */
export function getHotArticles() {
    return request({
        url: "/articles/hot",
        method: 'POST'
    })
}

/**
 * 获取最新文章列表
 */
export function getNewArticles() {
    return request({
        url: "/articles/new",
        method: 'POST'
    })
}

/**
 * 获取文章归档列表
 */
export function getArchives() {
    return request({
        url: "/articles/listArchives",
        method: 'POST'
    })
}

/**
 * 获取文章详情
 */
export function findArticleDetailById(id) {
    return request({
        url: `/articles/view/${id}`,
        method: 'post'
    })
}